export const forgotPasswordES = {
  main: 'Recuperar Contraseña',
  placeholder: 'Ingrese su correo electrónico y le enviaremos un enlace para volver a su cuenta.',
  send: 'Enviar',
  success: 'Se ha enviado el código de verificación a {{email}}'
}